import * as Types from '../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RolePermissionsFragment = { __typename?: 'CustomRole', id: string, name: string, description?: string | null, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'RolePermission', resource: Types.PermissionResource, action: Types.PermissionAction }> } };

export type RoleQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  organisationId: Types.Scalars['String']['input'];
}>;


export type RoleQuery = { __typename?: 'Query', customRole?: { __typename?: 'CustomRole', id: string, name: string, description?: string | null, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'RolePermission', resource: Types.PermissionResource, action: Types.PermissionAction }> } } | null };

export type SaveRolePermissionsMutationVariables = Types.Exact<{
  rolePermissions?: Types.InputMaybe<Types.RolePermissionsInput>;
}>;


export type SaveRolePermissionsMutation = { __typename?: 'Mutation', setRolePermissions?: { __typename?: 'SetRolesPayload', customRole?: { __typename?: 'CustomRole', id: string, name: string, description?: string | null, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'RolePermission', resource: Types.PermissionResource, action: Types.PermissionAction }> } } | null } | null };

export const RolePermissionsFragmentDoc = gql`
    fragment RolePermissions on CustomRole {
  id
  name
  description
  permissions: rolePermissionsByOrganisationIdAndRoleId {
    nodes {
      resource
      action
    }
  }
}
    `;
export const RoleDocument = gql`
    query Role($id: String!, $organisationId: String!) {
  customRole(id: $id, organisationId: $organisationId) {
    ...RolePermissions
  }
}
    ${RolePermissionsFragmentDoc}`;

/**
 * __useRoleQuery__
 *
 * To run a query within a React component, call `useRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useRoleQuery(baseOptions: Apollo.QueryHookOptions<RoleQuery, RoleQueryVariables> & ({ variables: RoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
      }
export function useRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleQuery, RoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
        }
export function useRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoleQuery, RoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
        }
export type RoleQueryHookResult = ReturnType<typeof useRoleQuery>;
export type RoleLazyQueryHookResult = ReturnType<typeof useRoleLazyQuery>;
export type RoleSuspenseQueryHookResult = ReturnType<typeof useRoleSuspenseQuery>;
export type RoleQueryResult = Apollo.QueryResult<RoleQuery, RoleQueryVariables>;
export const SaveRolePermissionsDocument = gql`
    mutation SaveRolePermissions($rolePermissions: RolePermissionsInput) {
  setRolePermissions(input: $rolePermissions) {
    customRole {
      ...RolePermissions
    }
  }
}
    ${RolePermissionsFragmentDoc}`;

/**
 * __useSaveRolePermissionsMutation__
 *
 * To run a mutation, you first call `useSaveRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRolePermissionsMutation, { data, loading, error }] = useSaveRolePermissionsMutation({
 *   variables: {
 *      rolePermissions: // value for 'rolePermissions'
 *   },
 * });
 */
export function useSaveRolePermissionsMutation(baseOptions?: Apollo.MutationHookOptions<SaveRolePermissionsMutation, SaveRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRolePermissionsMutation, SaveRolePermissionsMutationVariables>(SaveRolePermissionsDocument, options);
      }
export type SaveRolePermissionsMutationHookResult = ReturnType<typeof useSaveRolePermissionsMutation>;
export type SaveRolePermissionsMutationResult = Apollo.MutationResult<SaveRolePermissionsMutation>;
export type SaveRolePermissionsMutationOptions = Apollo.BaseMutationOptions<SaveRolePermissionsMutation, SaveRolePermissionsMutationVariables>;